<script>
import LoaderIcon from '@components/loader-icon.vue'
import pdf from 'vue-pdf'

export default {
  components: {
    LoaderIcon,
    pdf,
  },
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadedRatio: 0,
      showPdfBox: true,
      loadingPdf: true,
    }
  },
  methods: {
    pdfLoaded: function () {
      this.loadingPdf = false
    },
    pdfError: function () {
      this.showPdfBox = false
    },
  },
}
</script>

<template>
  <div :class="$style.previewFile" v-on="$listeners">
    <div v-if="resource.assetFileExtension === 'pdf'" v-show="showPdfBox" :class="$style.previewFileBox">
      <div v-if="loadingPdf" :class="$style.previewFileBoxLoading">
        <LoaderIcon />
        {{ Math.floor(loadedRatio * 100) }}%
      </div>
      <pdf :src="resource.assetUrl" @loaded="pdfLoaded" @error="pdfError" @progress="loadedRatio = $event || 0"></pdf>
    </div>
    <div :class="$style.previewFileInfo">
      <div :class="$style.previewFileName">
        <p>{{ resource.assetFileName }}</p>
      </div>
      <div :class="$style.previewFileSize">
        <p>{{ resource.assetSize }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.previewFile {
  @media (max-width: $lg-breakpoint) {
    width: 327px;
    margin-top: 32px;
  }

  width: 411px;
  margin-top: 40px;
  overflow: hidden;
  cursor: pointer;
  background: $light-gray;
  border: 0.5px solid #d4d6d9;
  border-radius: 12px;

  &:hover {
    opacity: 0.8;
  }
}

.previewFileBox {
  @media (max-width: $lg-breakpoint) {
    width: 316px;
    height: 136px;
  }

  width: 400px;
  height: 171px;
  margin: 5px 5px 0 5px;
  overflow: hidden;
  background: $white;
  border-radius: 8px;
}

.previewFileBoxLoading {
  margin-top: 80px;
  text-align: center;
}

.previewFileInfo {
  display: table-row;
}

.previewFileName {
  @media (max-width: $lg-breakpoint) {
    width: 231px;
    max-width: 231px;
    padding-left: 24px;
  }

  display: table-cell;
  width: 287px;
  max-width: 287px;
  padding: 19px 0 19px 44px;
  word-wrap: break-word;
  overflow-wrap: break-word;

  p {
    @media (max-width: $lg-breakpoint) {
      line-height: 14px;
    }

    width: 100%;
    font-size: 12px;
    font-weight: 700;
    color: $dark-gray;
  }
}

.previewFileSize {
  @media (max-width: $lg-breakpoint) {
    width: 94px;
  }

  display: table-cell;
  width: 123px;
  padding: 19px 30px 19px 0;
  text-align: right;
  vertical-align: middle;

  p {
    width: 100%;
    font-size: 10px;
    color: $dark-gray;
  }
}
</style>
